import { sendEventToDelphoi } from 'utils/send';
import { createDelphoiData } from 'utils/delphoiHelper';
import { DelphoiEventData } from 'types/event';
import { SendRaffleEventProps } from '../../types/common.types';

export function sendRaffleEvent({
  drawId,
  tab,
  action,
  ticketCount,
}: SendRaffleEventProps): void {
  sendEventToDelphoi(
    createDelphoiData({
      action,
      event: 'lottery',
      tv023: 'digital_services_raffle',
      ...(ticketCount && { tv051: ticketCount }),
      ...(drawId && { tv067: drawId }),
      tv070: tab,
    })
  );
}

export function sendEventToDelphoiForCoBrandedBannerShownOnSuccessPage(
  eventData: DelphoiEventData
): void {
  sendEventToDelphoi(
    createDelphoiData({
      ...eventData,
      tv019: 'https://digitalservices.trendyol.com/success',
      tv020: 'raffle_payment_success',
      tv021: 'https://digitalservices.trendyol.com/checkout',
      tv023: 'raffle_payment_success',
    })
  );
}

export function sendEventToDelphoiForCreditOfferShownOnSuccessPage(
  eventType: string
): void {
  sendEventToDelphoi(
    createDelphoiData({
      event: 'creditcomparison',
      tv003: eventType,
      tv067: 'raffle_payment_success_page',
    })
  );
}

export function sendEventToDelphoiForCoBrandedBannerSuccessPayment(
  eventData: DelphoiEventData
): void {
  sendEventToDelphoi(
    createDelphoiData({
      ...eventData,
      tv023: 'raffle_payment_success',
    })
  );
}
